import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Geannuleerd: {{reason}}',
    fulfilled: 'Deze bestelling is succesvol afgehandeld',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'Niet geaccepteerd',
    [OrderRejectionReason.ClosingSoon]: 'Sluit binnenkort',
    [OrderRejectionReason.ItemUnavailable]: 'Artikel niet beschikbaar',
    [OrderRejectionReason.OrderTooBig]: 'Bestelling te groot',
    [OrderRejectionReason.CustomerMistake]: 'Klantfout',
    [OrderRejectionReason.Other]: 'Overig',
    fully_refunded: 'Bestelling volledig terugbetaald',
  },
};
